import React, { useState, useEffect } from 'react';
import { api_host } from "../../common/globals/constants";
import {
    Typography,
    Box,
    Grid,
    IconButton,
    Popover,
    Tooltip,
    CircularProgress,
    TextField,
    TablePagination,
    InputAdornment,
  } from "@material-ui/core";
import { useInterval } from "../../hooks/useInterval";
import { Link } from "react-router-dom";
import { Alert } from "@material-ui/lab";
import HelpIcon from "@material-ui/icons/Help";
import UpdateIcon from '@mui/icons-material/Update';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import MonitorIcon from '@mui/icons-material/Monitor';
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';
import SearchIcon from '@mui/icons-material/Search';

import moment from 'moment-timezone'
import 'moment/locale/es'
import { useTranslation } from 'react-i18next';
import { getQueryParams } from '../../utils/fns/get-query-params';
moment.locale('es')

const sortObjetivosByColor = (objetivos) => {
    const colores = {
        0: "#d42323",
        1: "#dacc1d",
        2: "#da8e1d",
        3: "#3bb71c",
        4: "#b3b3b3",
    };
    const sortedObjetivos = [];
    
    Object.values(colores).forEach(color => {
        objetivos.forEach(objetivo => {
            if (objetivo.color === color) {
                sortedObjetivos.push(objetivo);
            }
        });
    });
    return sortedObjetivos;
};

const Step = ({ title, time, color }) => {
    return (
        <tr>
            <td style={{ display: "flex", alignItems: "center", borderBottom: `1px solid #d4d4d8`, paddingTop: "0.5rem", paddingBottom: "0.5rem" }}>
                <div style={{ width: "0.5rem", height: "1.25rem", marginRight: "0.5rem", backgroundColor: color }}></div>
                {title}
            </td>
            <td style={{ textAlign: "right", borderBottom: `1px solid #d4d4d8`, padding: "0.5rem" }}>{time}</td>
        </tr>
    );
};

const IconService = ({ service }) => {
    if (service == 700) {
        return (<PhoneIphoneIcon style={{ marginLeft: "0.5rem" }} />)
    }else if (service == 666) {
        return (<PhoneEnabledIcon style={{ marginLeft: "0.5rem" }} />)
    }else{
        return (<MonitorIcon style={{ marginLeft: "0.5rem" }} />)
    }
}

const getImagenAtentus = (tamano) => {
    if (tamano > 960) {
        return "/images/logo_atentus_azul.png";
    } else {
        return "/images/logo_circulo_atentus.png";
    }
};

const getJustified = (tamano, tipo) => {
    if (tamano > 960) {
        if (tipo === "titulo") {
            return "flex-start";
        }else{
            return "flex-end";
        }
    } else {
        return "center";
    }
};

const playSound = () => {
    const audio = new Audio('/audios/alert.mp3');
    audio.play();
};

const ThresholdAvailability = () => {
    const { t } = useTranslation();
    const [objetivos, setObjetivos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [dateUpdate, setDateUpdate] = useState(moment().locale('es').format("DD/MM/YYYY, HH:mm:ss"));
    const [infoTarget, setInfoTarget] = useState(null);
    const [alerta, setAlerta] = useState(false);
    const [imagen, setImagen] = useState("");
    const [titulo, setTitutlo] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(6);
    let token = sessionStorage.getItem("key");
    let user = sessionStorage.getItem('user');
    const dateMilisegundos = Date.now();

    useInterval(() => {
        fetchData();
        setDateUpdate(moment().locale('es').format("DD/MM/YYYY, HH:mm:ss"));
    }, 300000);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {

        fetch(`${api_host}/reporte/online/indicadores/getFlashboardInfo/?&token=${token}&user=${user}&start=${dateMilisegundos}`)
            .then(response => response.json())
            .then(data => {
                setObjetivos(data.objetivos);
                setImagen(data.info.imagen);
                setTitutlo(data.info.titulo);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    };

    const sortedObjetivos = sortObjetivosByColor(objetivos);

    function onClickInfo(event) {
        setInfoTarget(event.currentTarget);
    }

    function onCloseInfo() {
        setInfoTarget(null);
    }

    useEffect(() => {
        if (alerta) {
            playSound();
        }
    }, [alerta]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setPage(0); // Resetear la página al cambiar el término de búsqueda
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const filteredObjetivos = sortedObjetivos.filter(item =>
        item.nombre.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const paginatedObjetivos = filteredObjetivos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const generateArray = (length) => {
        const result = [];
        let i = 6;
        while (i <= length) {
            result.push(i);
            i += 6;
        }
        if (result[result.length - 1] < length) {
            result.push(result[result.length - 1] + 6);
        }
        return result;
    };

    const rowsPerPageOptions = generateArray(objetivos.length);

    return (
        <>
            {loading ? (
                <Grid style={{fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif', height: '85px', fontSize: '14px', color: '#666666', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
                        <CircularProgress variant="indeterminate" size={24} thickness={4} />
                    </Grid>
            <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '24px', padding: "0.5rem" }} >
                { (t && typeof t === 'function') ? (t('flashboard.loading.info') || 'Cargando Información') : 'Cargando Información' }
            </Grid>
                </Grid>
            ) : (
            <Grid container style={{ padding: '15px' }}>
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', padding: "0.5rem" }} >
                    <img style={{height: '50px', maxWidth: '315px'}} src={imagen} alt="logo cliente" />
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: "0.5rem" }} >
                    <img style={{height: '50px'}} src={getImagenAtentus(window.innerWidth)} alt="logo atentus" />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ display: 'flex', alignItems: 'center', justifyContent: getJustified(window.innerWidth, "titulo"), padding: "0.5rem" }} >
                    <Typography variant="h3" style={{color: '#6c757d'}} >
                            <strong>{titulo}</strong>
                    </Typography >
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ color: '#6c757d', display: 'flex', alignItems: 'center', justifyContent: getJustified(window.innerWidth, "update") }}>
                    <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', height: '24px', padding: "0.5rem" }} >
                        <UpdateIcon/>
                    </Grid>
                    <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', height: '24px', padding: "0.5rem" }} >
                        <strong>{ (t && typeof t === 'function') ? (t('text.last-update') || 'Última actualización') : 'Última actualización' }: {dateUpdate}</strong>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: "0.5rem" }} >
                    <Alert severity="info" style={{ width: "100%", border: "3px solid #f5f5f5", display: 'flex', justifyContent: 'start', alignItems: 'center', height: '2.5rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            { (t && typeof t === 'function') ? (t('flashboard.alert.message') || 'Para cambiar parámetros de este flashboard ir a la siguiente sección') : 'Para cambiar parámetros de este flashboard ir a la siguiente sección' }
                            <Link
                                to={{
                                pathname: "manageObjectives",
                                search: getQueryParams(),
                                query: { tab: 6 },
                                }}
                            >
                                <b>&nbsp;{ (t && typeof t === 'function') ? (t('flashboard.alert.link.config') || 'Configurar objetivos.') : 'Configurar objetivos.' }</b>
                            </Link>
                            <Tooltip title={ (t && typeof t === 'function') ? (t('flashboard.info.title') || 'Información') : 'Información' }>
                                <IconButton onClick={onClickInfo}>
                                <HelpIcon style={{ color: "#7786fc" }} />
                                </IconButton>
                            </Tooltip>
                        </div>
                    </Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3} style={{ padding: "0.5rem" }}>
                <Box
                    component="form"
                    noValidate
                    autoComplete="off"
                    >
                    <TextField
                        size="small"
                        fullWidth
                        label={ (t && typeof t === 'function') ? (t('text.search') || 'Buscar') : 'Buscar' }
                        placeholder={ (t && typeof t === 'function') ? (t('flashboard.search.placeholder') || 'Buscar objetivo') : 'Buscar objetivo' }
                        variant="outlined"
                        value={searchTerm}
                        onChange={handleSearchChange}                        
                        onKeyDown={(event) => {
                            if (event.key === 'Escape') {
                                setSearchTerm('');
                                event.target.blur();
                            }
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon />
                                </InputAdornment>
                            )
                        }}
                    />
                </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={9} lg={9} xl={9} style={{ justifyContent: "flex-end" }}>
                    <TablePagination
                        component="div"
                        count={filteredObjetivos.length}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        rowsPerPageOptions={rowsPerPageOptions}
                        labelDisplayedRows={({ from, to, count }) => ( (t && typeof t === 'function') ? (`${from}-${to} ${ (t('text.of') || 'de') } ${count}`) : `${from}-${to} de ${count}` ) }
                        labelRowsPerPage={ (t && typeof t === 'function') ? (t('flashboard.list.pagination.elements-count') || 'Elementos por página') : 'Elementos por página' }
                    />
                </Grid>
                <Grid container>
                    {paginatedObjetivos.map(item => {
                        if (sessionStorage.getItem(item.id_objetivo) != null && item.color != "#d42323") {
                            sessionStorage.removeItem(item.id_objetivo)
                        }
                        if (sessionStorage.getItem(item.id_objetivo) == null && item.color == "#d42323") {
                            sessionStorage.setItem(item.id_objetivo, item.color)
                            setAlerta(true)
                        }

                        if (item.umbral !== undefined) {
                            return (
                                <Grid item container xs={12} sm={6} md={6} lg={4} xl={3} style={{ padding: "5px" }}>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ background: "#fff", border: "4px solid", borderColor: item.color, padding: "1rem", borderRadius: "0.5rem" }}>
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "0.5rem" }}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <div style={{ borderRadius: "50%", width: "1rem", height: "1rem", marginRight: "0.5rem", backgroundColor: item.color }}></div>
                                            <h2 style={{ fontSize: "1.25rem", fontWeight: "bold", textAlign: "center", margin: 0 }}>{item.nombre}</h2>
                                            <IconService service={item.servicio} />
                                        </div>
                                    </div>
                                        <div>
                                            {item.pasos !== undefined && item.pasos.length > 0 ?
                                                item.pasos[0].tiempo_respuesta === "--" ?
                                                    <div style={{textAlign: "center", background: "#e4e4e7", padding: "0.5rem", marginBottom: "0.5rem"}}>
                                                        <span style={{ color: "#000000" }}>
                                                            <strong>{ (t && typeof t === 'function') ? (t('modal.objective.render.no-data') || 'NO HAY DATOS') : 'NO HAY DATOS' }</strong>
                                                        </span>
                                                    </div>
                                                : ""
                                            :   <div style={{textAlign: "center", background: "#e4e4e7", padding: "0.5rem", marginBottom: "0.5rem"}}>
                                                    <span style={{ color: "#000000" }}>
                                                        <strong>{ (t && typeof t === 'function') ? (t('flashboard.objective.noConfig') || 'NO POSEE CONFIGURACIÓN ACTIVA') : 'NO POSEE CONFIGURACIÓN ACTIVA' }</strong>
                                                    </span>
                                                </div>
                                            }
                                            {item.pasos !== undefined && item.pasos.length > 0 ?
                                                <div style={{textAlign: "left", background: "#e4e4e7", padding: "0.5rem", marginBottom: "0.5rem"}}>
                                                    <span style={{ color: "#71717a" }}>{ (t && typeof t === 'function') ? (t('flashboard.list.card.threshold') || 'Umbral definido') : 'Umbral definido' } {item.umbral} s</span>
                                                </div>
                                            : ""
                                            }
                                        </div>
                                        <table style={{ width: "100%" }}>
                                            {item.pasos !== undefined && item.pasos.length > 0 ?
                                                <thead>
                                                    <tr>
                                                        <th style={{ textAlign: "left", fontWeight: "bold" }}>{ (t && typeof t === 'function') ? (t('flashboard.table.header.step') || 'Paso') : 'Paso' }</th>
                                                        <th style={{ textAlign: "right", fontWeight: "bold" }}>{ (t && typeof t === 'function') ? (t('flashboard.table.header.responseThreshold') || 'Tiempo de respuesta') : 'Tiempo de respuesta' }</th>
                                                    </tr>
                                                </thead>
                                                : ""
                                            }
                                            <tbody>
                                                {item.pasos !== undefined && item.pasos.length > 0 ?
                                                    item.pasos.map(paso => {
                                                        return (
                                                            <Step style={{ borderBottom: "1px solid" }} title={paso.nombre_paso} time={paso.tiempo_respuesta + " s"} color={paso.estado} />
                                                        )
                                                    })
                                                : ""
                                                }
                                            </tbody>
                                        </table>
                                    </Grid>
                                </Grid>
                            );
                        }
                        return null;
                    })}
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ justifyContent: "flex-end" }}>
                    <TablePagination
                        component="div"
                        count={filteredObjetivos.length}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        rowsPerPageOptions={rowsPerPageOptions}
                        labelRowsPerPage={ (t && typeof t === 'function') ? (t('flashboard.list.pagination.elements-count') || 'Elementos por página') : 'Elementos por página' }
                    />
                </Grid>
            </Grid>
            )}
            <Popover
                anchorEl={infoTarget}
                open={Boolean(infoTarget)}
                onClose={onCloseInfo}
                PaperProps={{
                style: { width: 600, backgroundColor: "rgba(70, 70, 70)" },
                }}
                transformOrigin={{
                vertical: "top",
                horizontal: "right",
                }}
            >
                <Box padding={2}>
                    <Typography variant="body1" style={{ color: "white" }}>
                        <div style={{ display: 'flex', alignItems: 'right' }}>
                            { (t && typeof t === 'function') ? (t('flashboard.popover.text2') || 'Este Flashboard muestra el último evento del objetivo y los pasos, así como el tiempo de respuesta más reciente de cada paso.') : 'Este Flashboard muestra el último evento del objetivo y los pasos, así como el tiempo de respuesta más reciente de cada paso.' }
                        </div>
                    </Typography>
                    <Typography variant="body1" style={{ color: "white", display: "ruby" }}>
                        { (t && typeof t === 'function') ? (t('flashboard.info.threshold') || 'Se define un umbral para cada objetivo en la sección "Configurar Objetivos" pestaña "Flashboard Visibilidad". El umbral es el tiempo de respuesta promedio máximo permitido para todos los pasos, que el objetivo puede alcanzar para ser considerado aceptable por el cliente o usuario. Si este umbral se excede, el objetivo cambiará a color') : 'Se define un umbral para cada objetivo en la sección "Configurar Objetivos" pestaña "Flashboard Visibilidad". El umbral es el tiempo de respuesta promedio máximo permitido para todos los pasos, que el objetivo puede alcanzar para ser considerado aceptable por el cliente o usuario. Si este umbral se excede, el objetivo cambiará a color' }
                    </Typography>
                    <br/>
                    <br/>
                    <Typography variant="body1" style={{ color: "white" }}>
                        <div style={{ display: 'flex', alignItems: 'right' }}>
                            <strong>{ (t && typeof t === 'function') ? (t('flashboard.popover.text3') || 'La prioridad de visibilidad y la descripción es la siguiente:') : 'La prioridad de visibilidad y la descripción es la siguiente:' }</strong>
                        </div>
                    </Typography>
                    <Typography variant="body1" style={{ color: "white" }}>
                        <div style={{ display: 'flex', alignItems: 'right' }}>
                            <div style={{ width: '15px', height: '15px', borderRadius: '50%', marginRight: '5px', backgroundColor: '#d42323',}}></div>
                            <strong>{ (t && typeof t === 'function') ? (t('objective.status.downtime') || 'Downtime') : 'Downtime' }:</strong> 
                        </div>
                    </Typography>
                    <Typography variant="body1" style={{ color: "white" }}>
                        { (t && typeof t === 'function') ? (t('flashboard.popover.text.downtime.description') || 'Todos los puntos de observación del monitoreo presentan un error.') : 'Todos los puntos de observación del monitoreo presentan un error.' }
                    </Typography>

                    <Typography variant="body1" style={{ color: "white" }}>
                        <div style={{ display: 'flex', alignItems: 'right' }}>
                            <div style={{ width: '15px', height: '15px', borderRadius: '50%', marginRight: '5px', backgroundColor: '#dacc1d',}}></div>
                            <strong>{ (t && typeof t === 'function') ? (t('objective.status.partial') || 'Downtime Parcial') : 'Downtime Parcial' }:</strong> 
                        </div>
                    </Typography>
                    <Typography variant="body1" style={{ color: "white" }}>
                        { (t && typeof t === 'function') ? (t('flashboard.popover.text.downtime-parcial.description') || 'Uno o más puntos de observación del monitoreo presentan un error.') : 'Uno o más puntos de observación del monitoreo presentan un error.' }
                    </Typography>

                    <Typography variant="body1" style={{ color: "white" }}>
                        <div style={{ display: 'flex', alignItems: 'right' }}>
                            <div style={{ width: '15px', height: '15px', borderRadius: '50%', marginRight: '5px', backgroundColor: '#da8e1d',}}></div>
                            <strong>{ (t && typeof t === 'function') ? (t('flashboard.info.warning.title') || 'Warning Umbral Tiempo Respuesta') : 'Warning Umbral Tiempo Respuesta' }:</strong> 
                        </div>
                    </Typography>
                    <Typography variant="body1" style={{ color: "white" }}>
                        { (t && typeof t === 'function') ? (t('flashboard.popover.text.warning.description') || 'Se superó el umbral de tiempo de respuesta promedio de todos los pasos definido para el objetivo.') : 'Se superó el umbral de tiempo de respuesta promedio de todos los pasos definido para el objetivo.' }
                    </Typography>

                    <Typography variant="body1" style={{ color: "white" }}>
                        <div style={{ display: 'flex', alignItems: 'right' }}>
                            <div style={{ width: '15px', height: '15px', borderRadius: '50%', marginRight: '5px', backgroundColor: '#3bb71c',}}></div>
                            <strong>{ (t && typeof t === 'function') ? (t('objective.status.uptime') || 'Uptime') : 'Uptime' }:</strong>
                        </div>
                    </Typography>
                    <Typography variant="body1" style={{ color: "white" }}>
                        { (t && typeof t === 'function') ? (t('flashboard.popover.text.uptime.description') || 'Todos los puntos de observación del monitoreo no presentan inconvenientes.') : 'Todos los puntos de observación del monitoreo no presentan inconvenientes.' }
                    </Typography>

                </Box>
            </Popover>
        </>
    );
};

export default ThresholdAvailability;